module.exports = __webpack_public_path__ + "img/5类安全终端设备.9e76293a.png";